import { render } from "./BuyerCard.vue?vue&type=template&id=4916a4d8&ts=true&lang=pug"
import script from "./BuyerCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyerCard.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__